import _ from 'lodash';

export const WINDOW_STATES = {
    VISIBLE: 'VISIBLE',
    HIDDEN: 'HIDDEN',
};

export const WINDOWS = {
    VEHICLE_MANAGEMENT_DIALOG: 'VEHICLE_MANAGEMENT_DIALOG',
    VEHICLE_SELECT_DIALOG: 'VEHICLE_SELECT_DIALOG',
    PORTLET_CONFIGURATION_WINDOW: 'PORTLET_CONFIGURATION_WINDOW',
    ROUTE_SCHEDULE: 'routeSchedulerWindow',
    ROUTES_DIALOG: 'routesDialog',
    ALERT_DIALOG: 'ALERT_DIALOG',
    YES_NO_DIALOG: 'YES_NO_DIALOG',
    EXTERNAL_SYSTEM_DIALOG: 'EXTERNAL_SYSTEM_DIALOG',
    ADD_GEO_ZONE_WINDOW: 'ADD_GEO_ZONE_WINDOW',
};

export const getWindowsState = (state, portletId) => ({
    windowsState: _.get(state, `windows.${portletId}`, {}),
});
export const getWiredWindowsState = (state, wiredPortletId) => ({
    wiredWindowsState: _.get(state, `windows.${wiredPortletId}`, {}),
});

export const isWindowVisible = (props, name, defaultValue = WINDOW_STATES.HIDDEN) =>
    _.get(props, `windowsState.${name}.state`, defaultValue) === WINDOW_STATES.VISIBLE;

export const getWindowProps = (props, name) => _.get(props, `windowsState.${name}`, {});

export const getWindowPropertyByName = (props, windowName, propertyName) =>
    _.get(props, `windowsState.${windowName}.${propertyName}`, undefined);
